import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import AspectRatioBox from "@ingka/aspect-ratio-box";
import Image from "@ingka/image";
import SSRIcon from "@ingka/ssr-icon";
import person from "@ingka/ssr-icon/paths/person";
import personSmall from "@ingka/ssr-icon/paths/person-small";
import cx from "classnames";
const Avatar = (props) => {
  const {
    size = "medium",
    prefix = "",
    withIcon,
    text,
    imageProps,
    variant = "primary",
    className,
    onClick,
    disabled,
    staticColour,
    screenReaderText,
    ...other
  } = props;
  let contentType;
  if (imageProps) {
    contentType = "image";
  } else if (withIcon) {
    contentType = "icon";
  } else {
    contentType = "text";
  }
  const baseClass = `${prefix}avatar`;
  const classes = cx(
    baseClass,
    onClick && `${baseClass}--btn`,
    `${baseClass}--${size}`,
    `${baseClass}--${variant}`,
    `${baseClass}--${contentType}`,
    staticColour && `${baseClass}--static`,
    className
  );
  const avatarContent = /* @__PURE__ */ jsxs(Fragment, { children: [
    contentType === "icon" && /* @__PURE__ */ jsx(SSRIcon, { className: cx(`${baseClass}__icon`), prefix, paths: size === "xsmall" ? personSmall : person }),
    contentType === "image" && /* @__PURE__ */ jsx(AspectRatioBox, { ratio: "square", prefix, children: /* @__PURE__ */ jsx(Image, { className: `${baseClass}__image`, prefix, ...imageProps }) }),
    contentType === "text" && /* @__PURE__ */ jsx("span", { className: cx(`${baseClass}__text`), children: text }),
    /* @__PURE__ */ jsx("span", { className: cx(`${baseClass}__sr-text`), children: screenReaderText })
  ] });
  return onClick ? /* @__PURE__ */ jsx(
    "button",
    {
      className: classes,
      onClick,
      disabled,
      ...other,
      children: avatarContent
    }
  ) : /* @__PURE__ */ jsx(
    "span",
    {
      className: classes,
      ...other,
      children: avatarContent
    }
  );
};
Avatar.displayName = "Avatar";
var Avatar_default = Avatar;
export {
  Avatar_default as default
};
